import { render, staticRenderFns } from "./nullPage.vue?vue&type=template&id=e5477d70"
import script from "./nullPage.vue?vue&type=script&lang=js"
export * from "./nullPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports